import * as React                from 'react';
import * as PropTypes            from 'prop-types';
import * as cx                   from 'classnames';
import { ContactContainerProps } from './ContactTypes';
import {
    capitalizeFirstLetter,
    obfuscatePhoneNumber,
    formatAccountUrl
}                                from '../../helpers/stringUtils';
import {
    getQueryStringValueByKey
}                                from '../../helpers/queryStringUtils';
import icons                     from '../../icons';
import LoadingAnimation          from '../../components/LoadingAnimation';
import env                       from '../../env';

const getContactName = (contact) => {
    if (contact.name) {
        return capitalizeFirstLetter(contact.name);
    }

    if (contact.phone) {
        return obfuscatePhoneNumber(contact.phone);
    }

    return null;
};

export const LoadingContact: React.StatelessComponent<ContactContainerProps> = ({ contactPanelVisible }) => (
    <div className={cx('contactPanel', 'flexbox__column', 'border-left', {contactPanel__visible: contactPanelVisible})}>
        <LoadingAnimation />
    </div>
);

const showContactPanel = (contact) => contact && contact.account;
const callListId = getQueryStringValueByKey('calllist_id') && parseInt(getQueryStringValueByKey('calllist_id'), 10);

const ContactPanel: React.StatelessComponent<ContactContainerProps> = ({ contact, toggleContactPanel, contactPanelVisible, onDesktop, conversationId, history }, { translate }) => showContactPanel(contact) ? (
    <div className={cx('contactPanel', 'flexbox__column', 'border-left', {is__dnc: contact.isDnc}, {contactPanel__visible: contactPanelVisible})}>
        <div className="contactPanel__padding">
            <div className="contactPanel__actionButtons">
                <a className="actionButton contactPanel__actionButton" href={`${env.WEBAPP_HOST}accounts`}>
                    {translate('statflo_crm')}
                </a>
                <a className="actionButton contactPanel__actionButton" onClick={() => history.push(`/log/${conversationId}`)}>
                    {translate('log_an_activity')}
                </a>
            </div>
            {contact.isDnc &&
                <div className="contactPanel__contactDnc">
                    DNC
                </div>
            }
            <div className={cx('contactPanel__contactName', {is__dnc: contact.isDnc})}>
                {getContactName(contact)}
            </div>
            <div className="contactPanel__contactType">
                {contact.isPrimary ? translate('primary_contact') : ''}
            </div>
            <a className="actionButton contactPanel__actionButton contactPanel__accountLink" href={formatAccountUrl(contact.account.ban, true, callListId)}>
                {contact.account.banType === 'lead' ? translate('back_to_lead') : translate('back_to_account')}
            </a>
            <div className="contactPanel__island">
                <div className="contactPanel__accountName">
                    {contact.account.name}
                </div>
                <div className="contactPanel__planName">
                    {contact.subscription ? contact.subscription.plan : translate('plan_not_provided')}
                </div>
                <div className="contactPanel__planDevice">
                    {contact.subscription ? contact.subscription.device : translate('device_not_provided')}
                </div>
                <div className="contactPanel__planColumns">
                    <div className="contactPanel__planColumn">
                        <div className="title">
                            {translate('purchased')}
                        </div>
                        <div className="value">
                            {contact.subscription && contact.subscription.start_date ? contact.subscription.start_date : '–'}
                        </div>
                    </div>
                    <div className="contactPanel__planColumn">
                        <div className="title">
                            {translate('expires')}
                        </div>
                        <div className="value">
                            {contact.subscription && contact.subscription.expiration_date ? contact.subscription.expiration_date : '–'}
                        </div>
                    </div>
                    <div className="contactPanel__planColumn">
                        <div className="title">
                            {translate('balance')}
                        </div>
                        <div className="value">
                            {contact.subscription && contact.subscription.balance ? contact.subscription.balance : '–'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="contactPanel__closeContainer">
            <a className="contactPanel__closeIcon" onClick={toggleContactPanel}>
                {onDesktop ? null : icons.chevronUp}
            </a>
        </div>
    </div>
) : null;

export default ContactPanel;

ContactPanel.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/Contact/ContactPanelComponent.tsx